import React from "react";
import ChangeRequestContext from "src/context/ChangeRequestContext";
import {
  FileUploadFormikField,
  FileUploadFormikFieldProps,
} from "src/components/Fields/FileUpload";

export const ChangeRequestFormFileUploadFormikField: React.FC<
  Omit<FileUploadFormikFieldProps, "setDisplayingSnackbar">
> = (props) => {
  const { setDisplayingSnackbar } = React.useContext(ChangeRequestContext);
  return (
    <FileUploadFormikField
      {...props}
      setDisplayingSnackbar={setDisplayingSnackbar}
    />
  );
};
